import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import * as firebase from 'firebase/app';
import 'firebase/auth';

// import vgapi from "@/plugins/vgapi";
// import firebase from '@/plugins/fbase';

import vuemoment from 'vue-moment';

declare const window: any;

Vue.config.productionTip = false;

Vue.use(vuemoment);

const googleConfig = {
  apiKey: 'AIzaSyC6CUTLl9SkwG3tLcszisE1DKSubR0pSJE',
  clientId: '665663118788-sa98mfe7ness1pftlm5kr2vdk4dnq9c2.apps.googleusercontent.com',
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest'],
  scope: "https://www.googleapis.com/auth/classroom.courses https://www.googleapis.com/auth/classroom.coursework.me",
}

const firebaseConfig = {
  apiKey: "AIzaSyDyk0_IiMEO0YoQPOXQgp6i64BaJppGVYI",
  authDomain: "tl-mrskamau.firebaseapp.com",
  databaseURL: "https://tl-mrskamau.firebaseio.com",
  projectId: "tl-mrskamau",
  storageBucket: "tl-mrskamau.appspot.com",
  messagingSenderId: "809300698386",
  appId: "1:809300698386:web:40d6147936980acaf77fcb",
}

// Vue.use(firebase, firebaseConfig);
// Vue.use(vgapi, googleConfig);

function initGoogleAPI(config) {
  // Check for and add Google API Script
  if(!window.gapi) {
      
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://apis.google.com/js/api.js';
      script.onload = (e) => {
          window.gapi.load('client:auth2', () => {
              window.gapi.client.init(config);
              console.log('installed gapi');
              new Vue({
                router,
                store,
                render: h => h(App)
              }).$mount("#app");
          });
      }
      document.getElementsByTagName('head')[0].appendChild(script);
  }
}

function initFirebase(config) {
  firebase.initializeApp(config);
}

initFirebase(firebaseConfig);
initGoogleAPI(googleConfig);


